module.exports = __webpack_public_path__ + "static/img/function_post.35c6676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/function_post.png
// module id = GMPl
// module chunks = 37